export const MEDIA_COUNT_FEATURE = 'MEDIA_COUNT_FEATURE';
export const mediaCountFeature = (editorState, raw)=>{
    let emotes = 0;
    let emoji = 0;
    let images = 0;
    let mentions = 0;
    let video = 0;
    let previews = 0;
    for(const key in raw.entityMap){
        const entity = raw.entityMap[key];
        switch(entity.type){
            case 'EMOJI_TYPE':
                emoji++;
                break;
            case 'DA_COMM_EMOTE':
            case 'DA_OFF_EMOTE':
                emotes++;
                break;
            case 'wix-draft-plugin-gallery':
                if (entity.data && entity.data.data) {
                    images += entity.data.data.length;
                }
                break;
            case 'wix-draft-plugin-image':
                if (entity.data && entity.data.data) {
                    images++;
                }
                break;
            case 'wix-draft-plugin-giphy':
                if (entity.data) {
                    images++;
                }
                break;
            case 'mention':
                mentions++;
                break;
            case 'wix-draft-plugin-video':
                if (entity.data && entity.data.src) {
                    video++;
                }
                break;
            case 'wix-draft-plugin-link-preview':
                if (entity.data) {
                    previews++;
                }
                break;
            default:
        }
    }
    return {
        type: MEDIA_COUNT_FEATURE,
        data: {
            emoji,
            emotes,
            images,
            mentions,
            video,
            previews
        }
    };
};

//# sourceMappingURL=mediaCount.js.map